import { Component, ElementRef, OnInit, ViewChild,HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';  
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GlobalVariable } from '../globals';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { GarageDetailsService } from '../garage-details/garage-details-service';
Swiper.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: 'app-tyre-issue-details',
  imports: [CommonModule,FormsModule,ReactiveFormsModule,MatIconModule,GoogleMapsModule],
  templateUrl: './tyre-issue-details.html',
  styleUrl: './tyre-issue-details.scss',
})
export class TyreIssueDetails implements OnInit {
  key: any;  
  garageData: any = {
    reviews: [
      { comment: 'Great service!', rating: 5 },
      { comment: 'Very professional.', rating: 4.5 },
      { comment: 'Highly recommend!', rating: 5 },
      { comment: 'Quick and easy!', rating: 4 },
      { comment: 'Excellent!', rating: 5 }
    ]
  };
  visibleReviews: any[] = [];
  currentIndex = 0;           
  slidesToShow = 3;
  coupons: any[] = [];
  selectedCoupon: any = null;
  callbackForm: FormGroup;
  userId = GlobalVariable.userId;
  private scrollInterval: any;
  safeButtonLink!: SafeResourceUrl;
  safeMapUrl!: SafeResourceUrl;
  successMessage: string = '';
  couponForm: FormGroup;
  isPrevDisabled = true;
  isNextDisabled = false;
  showIssueDropdown = true;
  fromServicePage = false; 
  selectedServiceKey = ''; 
  showQuickBookBtn = false;
  // swiperInstance!: Swiper;
  isModalOpen = false;
  swiperInstance: any;
  showCta = false;
  showRequestBtn = false;
  isPageLoading = true;        // for garage details + initial page
  isCouponsLoading = false;   // for coupons
  isSubmitting = false;  
  isNavbarWhite = false;
    services = [
    { key: 'PERIODIC_SERVICE', label: 'Periodic Service' },
    { key: 'DENTING_PAINTING', label: 'Denting & Painting' },
    { key: 'CAR_NOT_STARTING', label: 'Car Not Starting' },
    { key: 'BRAKE_ISSUES', label: 'Brake Noise / Weak Brakes' },
    { key: 'ENGINE_ISSUES', label: 'Engine Noise / Warning Light' },
    { key: 'AC_ISSUES', label: 'AC Not Cooling Properly' },
    { key: 'SUSPENSION_STEERING', label: 'Suspension / Steering Issues' },
    { key: 'TYRE_ISSUES', label: 'Tyres Worn Out / Vibrating' }
  ];
  // Google maps Integration
  center: any;
  zoom: number = 14;
  marker: any;
  mapOptions: google.maps.MapOptions = {
  disableDefaultUI: true,
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: true,
 
  
};
  // End Google maps Integration

  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  @ViewChild('markerElem', { static: false }) markerElem!: MapMarker;
  @ViewChild('slide1') slide1!: ElementRef;
  @ViewChild('slide2') slide2!: ElementRef;
  @ViewChild('slide3') slide3!: ElementRef;
  @ViewChild('heroSwiper', { static: false }) heroSwiper!: ElementRef;
  @ViewChild('heroSection', { static: true }) heroSection!: ElementRef;


  constructor(
    private garageService: GarageDetailsService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
   ) {this.callbackForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      registrationNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$')
        ]
      ],
      issue: ['']
    });
    this.couponForm = this.fb.group({
    couponName: ['', Validators.required],
    couponMobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
    couponIssue: ['']
  });
  }

  ngOnInit(): void {
  this.key =
    this.route.snapshot.paramMap.get('key') ||
    localStorage.getItem('garageKey');

  if (!this.key) {
    console.error('Garage key missing');
    return;
  }
     const serviceKeyFromRoute = this.route.snapshot.data['serviceKey'];

  if (serviceKeyFromRoute) {
    this.fromServicePage = true;
    this.selectedServiceKey = serviceKeyFromRoute;
    this.showIssueDropdown = false;
  } else {
    this.fromServicePage = false;
    this.showIssueDropdown = true;
  }
  this.loadGarageDetails();
  this.loadCoupons();
}


  ngAfterViewInit(): void {

  const testimonialSwiper = new Swiper('.testimonial-swiper', {
    slidesPerView: 1,
    // loop: true,
    rewind: true,
    pagination: {
      el: '.swiper-pagination-testimonial',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-new',
      prevEl: '.swiper-button-prev-new',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  // Makes / Cars Logos Swiper
 const makesSwiper = new Swiper('.makes-swiper-container', {
  slidesPerView: 1,
  loop: false,
  rewind: false,
  autoplay: false,

  navigation: {
    nextEl: '.swiper-button-next-makes',
    prevEl: '.swiper-button-prev-makes',
  },

  observer: true,
  observeParents: true,
});
   // 🔹 HERO SWIPER (ADD ONLY)
  const heroSwiper = new Swiper('.hero-swiper', {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  // 🔹 HERO BUTTONS
  const heroNext = document.querySelector(
    '.hero-wrapper .swiper-button-next'
  ) as HTMLElement;

  const heroPrev = document.querySelector(
    '.hero-wrapper .swiper-button-prev'
  ) as HTMLElement;

  heroNext?.addEventListener('click', () => {
    heroSwiper.slideNext();
  });

  heroPrev?.addEventListener('click', () => {
    heroSwiper.slidePrev();
  });

  // Optional: update after init
  setTimeout(() => {
    testimonialSwiper.update();
    // makesSwiper.update();
  }, 300);

}

  @HostListener('window:scroll', [])
    onWindowScroll() {
      const heroSection = document.getElementById('hero-section');

      if (!heroSection) return;

      const rect = heroSection.getBoundingClientRect();

      // When hero section goes out of view (scroll passed it)
      const isAfterHero = rect.bottom <= 0;

      this.showRequestBtn = isAfterHero;
      this.isNavbarWhite = isAfterHero;
      if (!this.heroSection) return;

    const heroBottom =
      this.heroSection.nativeElement.getBoundingClientRect().bottom;

    // Show button only when hero is out of view
    this.showQuickBookBtn = heroBottom <= 0;
    }

  initCounters() {
    const counters = document.querySelectorAll('.counter');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target as HTMLElement;
          const target = parseInt(el.innerText.replace(/\D/g, ''), 10);
          let count = 0;
          const step = Math.ceil(target / 60);

          const interval = setInterval(() => {
            count += step;
            if (count >= target) {
              el.innerText = el.innerText.includes('%')
                ? target + '%'
                : target + '+';
              clearInterval(interval);
            } else {
              el.innerText = count.toString();
            }
          }, 20);

          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
  }

loadGarageDetails() {
   this.isPageLoading = true;
  this.garageService.getGarageDetails(this.key).subscribe({
    next: (res) => {
      if (res.code === 200 && res.data) {
        this.garageData = res.data;
        //  garage logo
        if (this.garageData.garageLogo) {
          const logos = this.garageData.garageLogo
            .split(',')
            .map((l: string) => l.trim())
            .filter(Boolean);

         this.garageData.primaryLogo = this.garageData?.garageLogo
          ? this.garageData.garageLogo.split(',')[0].trim()
          : 'assets/img/mobile_autoverse_logo.svg';
        } else {
          this.garageData.primaryLogo = 'assets/img/mobile_autoverse_logo.svg';
        }
         if (this.garageData.insuranceUrl) {
          this.garageData.insuranceUrls = this.garageData.insuranceUrl.split(',').filter((url: any) => url);
         }
          // Google maps Integration
          this.center = { lat: this.garageData?.latitude, lng: this.garageData?.longitude }; 
          this.marker = {
            position: { lat: this.garageData?.latitude, lng: this.garageData?.longitude },
            title: this.garageData?.name,
            options: { 
              animation: google.maps.Animation.DROP,
              icon: {
                url: './assets/img/google_map_icon.png',
                scaledSize: new google.maps.Size(30, 30)
              }
            },
            googleRatings: this.garageData?.googleRatings,
            googleReviewNumbers: this.garageData?.googleReviewNumbers,
            address: this.garageData?.address
          };
          // Google maps Integration
        
      
        // populate visibleReviews for first time
        // this.updateVisibleReviews();
        // wait a tick to ensure marker is ready
      setTimeout(() => {
        if (this.markerElem) {
          this.infoWindow.open(this.markerElem);
        }
      }, 500);

      }
       this.isPageLoading = false;
    },
    error: (err) => console.error(err)
  });
}

  /** 🔹 Coupons API */
  loadCoupons() {
    this.garageService.getCoupons(this.key).subscribe({
      next: (res) => {
        if (res.code === 200 && res.data) {
          this.coupons = res.data;
          console.warn('coupon-response', res);
        } else {
          console.warn('No coupons available:', res.message);
        }
      },
      error: (err) => console.error('Error fetching coupons:', err)
    });
  }

  /** Modal functions */
  openModal(coupon: any) {
  this.selectedCoupon = coupon;
  this.isModalOpen = true;
  console.log("Selected coupon:", coupon);
}


  closeModal() {
    this.selectedCoupon = null;
     this.isModalOpen = false;
  }


  getStars(rating: number): string[] {
    const stars: string[] = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) stars.push('full');
    if (hasHalf) stars.push('half');
    while (stars.length < 5) stars.push('empty');

    return stars;
  }

  applyCoupon(coupon: any) {
    console.log('Applying coupon:', coupon);
    // Later you can call your service here if needed
    // this.closeModal();
  }
  decodeEntities(str: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }
  openRequestModal() {
    this.isModalOpen = true;
    
    const modalEl = document.getElementById('requestCallBackModal');
    if (modalEl) {
      const modal = new (window as any).bootstrap.Modal(modalEl, {
        backdrop: false
      });
      modal.show();
    }
  }

   submitForm() {
    if (this.callbackForm.invalid){
      this.callbackForm.markAllAsTouched(); 
      return;
    }
    this.isSubmitting = true;
    const { name, mobile, registrationNumber ,issue } = this.callbackForm.value;

    const payload = {
      garageKey: this.key,
      userId: this.userId,
      name,
      phoneNumber: mobile,
      registrationNumber,
       issue: this.fromServicePage
      ? this.selectedServiceKey  
      : issue,
      couponId: this.selectedCoupon?.couponId || null,
      tagDeal: this.selectedCoupon?.tagDeal || null,
      tag: this.selectedCoupon?.tag || null,
      discount: this.selectedCoupon?.discount || null,
      validTill: this.selectedCoupon?.validTill || null,
      description: this.selectedCoupon?.description || null,
      couponCode: this.selectedCoupon?.couponCode || null,
    };

    this.garageService.createBooking(payload).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        if (res.code === 200) {
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          // ✅ hide the request callback modal first
          const requestModalEl = document.getElementById('requestCallBackModal');
          const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
          requestModal?.hide();
          this.isModalOpen = false;

          // ✅ wait a tick before showing success modal
          setTimeout(() => {
            const successModalEl = document.getElementById('successModal');
            if (successModalEl) {
              const successModal = new (window as any).bootstrap.Modal(successModalEl);
              successModal.show();
            }
          }, 200);

          // reset form
          this.callbackForm.reset();
          this.selectedCoupon = null;
          
          this.showIssueDropdown = !this.fromServicePage;
        } else {
          alert('Something went wrong. Please try again.');
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        console.error('Error creating booking:', err);
        alert('Error creating booking. Please try again.');
      }
    });
  }

  closeSuccessModal() {
    const successModalEl = document.getElementById('successModal');
    const successModal = (window as any).bootstrap.Modal.getInstance(successModalEl);
    successModal?.hide();

    // reload page or perform other actions
    location.reload();
  }
  applyCouponForm() {
    if (this.couponForm.invalid) {
      alert("Please enter Full Name and Mobile Number");
      return;
    }

    const { couponName, couponMobile, couponIssue } = this.couponForm.value;

    const payload = {
      garageKey: this.key,
      userId: this.userId,
      name: couponName,
      phoneNumber: couponMobile,
      issue: couponIssue,
      couponId: this.selectedCoupon?.couponId || null,
      tagDeal: this.selectedCoupon?.tagDeal || null,
      tag: this.selectedCoupon?.tag || null,
      discount: this.selectedCoupon?.discount || null,
      validTill: this.selectedCoupon?.validTill || null,
      description: this.selectedCoupon?.description || null,
      couponCode: this.selectedCoupon?.couponCode || null,
    };

    this.garageService.createBooking(payload).subscribe({
      next: (res) => {
        if (res.code === 200) {
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          const couponModalEl = document.getElementById('couponModal');
          if (couponModalEl) couponModalEl.style.display = 'none';

          const successModalEl = document.getElementById('successModal');
          if (successModalEl) {
            const successModal = new (window as any).bootstrap.Modal(successModalEl);
            successModal.show();
          }

          this.couponForm.reset();
          this.selectedCoupon = null;
        } else {
          alert("Error creating booking. Please try again.");
        }
      },
      error: (err) => {
        console.error("Error:", err);
        alert("Error creating booking. Please try again.");
      }
    });
  }

  prevSlide() {
    if (this.isPrevDisabled) return;
    this.currentIndex = Math.max(0, this.currentIndex - this.slidesToShow);
    this.updateVisibleReviews();
  }

  nextSlide() {
    if (this.isNextDisabled) return;
    this.currentIndex = Math.min(
      (this.garageData?.reviews?.length || 0) - this.slidesToShow,
      this.currentIndex + this.slidesToShow
    );
    this.updateVisibleReviews();
  }

  updateVisibleReviews() {
    this.visibleReviews = this.garageData?.reviews.slice(this.currentIndex, this.currentIndex + this.slidesToShow) || [];
  }
  ngOnDestroy() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
      }
    }

    startAutoScroll() {
      const container = document.querySelector('.insurance-logos') as HTMLElement;
      if (!container) return;

      this.scrollInterval = setInterval(() => {
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
          container.scrollTo({ left: 0, behavior: 'auto' });
        } else {
          container.scrollBy({ left: 1, behavior: 'smooth' });
        }
      }, 20);
    }

  scrollRight() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    if (container) {
      container.scrollBy({ left: 400, behavior: 'smooth' });
      setTimeout(() => this.checkButtons(container), 400);
    }
  }

  scrollLeft() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    if (container) {
      container.scrollBy({ left: -400, behavior: 'smooth' });
      setTimeout(() => this.checkButtons(container), 400);
    }
  }

  checkButtons(container: HTMLElement) {
    this.isPrevDisabled = container.scrollLeft <= 0;
    this.isNextDisabled =
      container.scrollLeft + container.clientWidth >= container.scrollWidth;
  }
  scrollReviewsRight() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    const card = container?.querySelector('.review-card') as HTMLElement;
    if (container && card) {
      container.scrollBy({ left: card.offsetWidth + 20, behavior: 'smooth' });
    }
  }

  scrollReviewsLeft() {
    const container = document.querySelector('.reviews-wrapper') as HTMLElement;
    const card = container?.querySelector('.review-card') as HTMLElement;
    if (container && card) {
      container.scrollBy({ left: -(card.offsetWidth + 20), behavior: 'smooth' });
    }
  }

    scrollLeftMake() {
    const container = document.querySelector('.makes-container') as HTMLElement;
    if (container) {
      container.scrollBy({ left: -300, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(container), 400);
    }
  }

  scrollRightMake() {
    const container = document.querySelector('.makes-container') as HTMLElement;
    if (container) {
      container.scrollBy({ left: 300, behavior: 'smooth' });
      setTimeout(() => this.checkScrollButtons(container), 400);
    }
  }
  checkScrollButtons(container: HTMLElement) {
    this.isPrevDisabled = container.scrollLeft <= 0;
    this.isNextDisabled =
      container.scrollLeft + container.clientWidth >= container.scrollWidth;
  }
  goToRegistrationDecode() {
    this.router.navigate(['registration-decode']);
  }

  // Google maps Integration
  get directionsLink() {
    return `https://www.google.com/maps/dir/?api=1&destination=${this.garageData?.latitude},${this.garageData?.longitude}`;
  }

  get largerMapLink() {
    return `https://www.google.com/maps/search/?api=1&query=${this.garageData?.latitude},${this.garageData?.longitude}`;
  }

  openInfo(marker: MapMarker) {
    this.infoWindow.open(marker);
  }
  // End Google maps Integration

// scrollTo(id: string) {
//   document.getElementById(id)
//     ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

//   const openDropdown = document.querySelector('.dropdown-menu.show');
//   openDropdown?.classList.remove('show');
// }
scrollTo(id: string) {
  // 1️⃣ Scroll to section
  document.getElementById(id)
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  // 2️⃣ Close open dropdown (if any)
  const openDropdown = document.querySelector('.dropdown-menu.show');
  openDropdown?.classList.remove('show');

  // 3️⃣ Close hamburger sidebar (offcanvas)
  const offcanvasEl = document.querySelector('.offcanvas-nav');
  if (offcanvasEl) {
    (window as any).bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
  }
}

 onCtaClick() {
    // Scroll to any section or open modal
    const target = document.getElementById('our-services');
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
heroPrev() {
  this.swiperInstance?.autoplay.stop();
  this.swiperInstance?.slidePrev();
}

heroNext() {
  this.swiperInstance?.autoplay.stop();
  this.swiperInstance?.slideNext();
}
private resolveGarageKey(): string | null {
  return (
    this.route.snapshot.paramMap.get('key') ||
    localStorage.getItem('garageKey')
  );
}
goToPeriodicpage() {
  this.router.navigate(['/periodic-service-details']);
}
goToSteeringpage() {
  this.router.navigate(['/steering-issue-details']);
}
goToTyrepage() {
  this.router.navigate(['/tyre-issue-details']);
}
goToAcpage() {
  this.router.navigate(['/ac-not-colling-details']);
}
goTobrakepage() {
  this.router.navigate(['/brake-noise-details.html']);
}
goTocarpage() {
  this.router.navigate(['/car-not-starting-details']);
}
goTodentingpage() {
  this.router.navigate(['/denting-and-painting-details']);
}
goTonoisepage() {
  this.router.navigate(['/engine-noise-details.html']);
}
onSidebarBookClick() {
  // Close hamburger offcanvas
  const offcanvasEl = document.querySelector('.offcanvas-nav');
  if (offcanvasEl) {
    (window as any).bootstrap.Offcanvas
      .getInstance(offcanvasEl)
      ?.hide();
  }

  // Open booking modal after sidebar closes
  setTimeout(() => {
    this.openRequestModal();
  }, 200);
}
goToGarageDetails() {
  this.router.navigate(['/garage-details', this.key]);
}
}





